import { cardClass } from './cardStyles'

export function Skeleton({ className = '' }: { className?: string }) {
  return <div aria-hidden className={`animate-pulse rounded bg-slate-200/70 ${className}`} />
}

export function CardSkeleton() {
  return (
    <div className={`${cardClass({ padding: 'md' })} shadow-lg shadow-sky-50`}>
      <div className="mb-4 flex items-center justify-between">
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-3 w-12" />
      </div>
      <Skeleton className="mb-3 h-5 w-2/3" />
      <Skeleton className="mb-2 h-3 w-full" />
      <Skeleton className="mb-2 h-3 w-[85%]" />
      <Skeleton className="h-3 w-1/2" />
    </div>
  )
}
